const Banner = () => {
  return (
    <div className="relative h-72 w-full">
      <div className="bg-[#000046] w-full text-2xl h-full  opacity-90"></div>
    </div>
  );
};
export default Banner;
